export const EvaluationText = {
  0: '만족해요',
  1: '별로예요',
};
